<div class="preview-indicator" *ngIf="isShown"></div>
